module.exports =
  global.performance &&
  global.performance.now ? function now() {
    return performance.now()
  } : Date.now || function now() {
    return +new Date
  }



//////////////////
// WEBPACK FOOTER
// ./node_modules/right-now/browser.js
// module id = 64
// module chunks = 0